// Query keys centralizadas y jerárquicas del dominio admin.
export const adminKeys = {
  all: ["admin"] as const,
  redmineUsers: () => [...adminKeys.all, "redmine-users"] as const,
} as const;
